import { render, staticRenderFns } from "./Technology.vue?vue&type=template&id=6996e03a&scoped=true"
import script from "./Technology.vue?vue&type=script&lang=js"
export * from "./Technology.vue?vue&type=script&lang=js"
import style0 from "./Technology.vue?vue&type=style&index=0&id=6996e03a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6996e03a",
  null
  
)

export default component.exports